// extracted by mini-css-extract-plugin
export default {"wrapper":"rE-z","button":"sE-z","alternate":"tE-z","disabled":"uE-z","paymentWarning":"vE-z","fadeIn":"wE-z"};